import { ThemeProvider , Toaster } from "@roberttamas/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "@/App";
import { AuthProvider } from "@/lib/auth";
import { queryClient } from "@/lib/query-client";

import "@/i18n";

import "@/index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider storageKey="wedding-admin-theme">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
